import React from "react";
import AddToCartToSeePrice from "./AddToCartToSeePrice";
import { VariantProps } from ".";
const D = (props: VariantProps) => {
  const {
    selectedProduct
  } = props;
  return <AddToCartToSeePrice {...props} showEnticement showLoginLink={selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers} data-sentry-element="AddToCartToSeePrice" data-sentry-component="D" data-sentry-source-file="D.tsx" />;
};
export default D;